import React, { useEffect } from "react";
import classes from "./Button.module.css";
import chevron from "../../assets/chevron-down.png";
import chevronUp from "../../assets/chevron-down (1).png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../I18n/Languages/LanguageContext";
import Spinner from "../Spinner/Spinner";

export default function ButtonStepper({
  activeStep,
  stepsLength,
  onNext,
  onBack,
  isLastStep,
  isPersonalFormValid = true,
  isEducationFormValid = true,
  isDeclarationFormValid = true,
  isSubmitWidth = false,
  isSubmitting = false,
}) {
  const { t } = useTranslation();

  const isFirstStep = activeStep === 0;
  const isCompleted = activeStep === stepsLength;
  const isNextDisabled =
    isCompleted ||
    (activeStep === 0 && !isPersonalFormValid) ||
    (activeStep === 1 && !isEducationFormValid) ||
    (activeStep === 2 && !isDeclarationFormValid);

  const navigate = useNavigate();

  useEffect(() => {
    if (isCompleted) {
      localStorage.setItem("activeStep", stepsLength);
      navigate("/FinishedAplication");
    }
  }, [isCompleted, navigate, stepsLength]);

  if (isCompleted) return null;

  return (
    <div className={classes.wrapper}>
      {activeStep > 0 && (
        <button
          className={classes.backBtn}
          onClick={onBack}
          disabled={isFirstStep}
        >
          <img src={chevronUp} alt="chevron" className={classes.chevron} />
          {t("back")}
        </button>
      )}

      <button
        className={`${classes.nextBtn} ${
          isSubmitWidth ? classes.submitWidth : ""
        }`}
        onClick={onNext}
        disabled={isNextDisabled || (isLastStep && isSubmitting)}
      >
        {isLastStep ? (
          isSubmitting ? (
            <Spinner />
          ) : (
            t("submit_application")
          )
        ) : (
          <>
            {t("continue")}
            <img src={chevron} alt="chevron" className={classes.chevron} />
          </>
        )}
      </button>
    </div>
  );
}
